import { Activity, TrendingUp, Calendar, Award } from 'lucide-react';
import { fmtAccountAge, fmtUsd } from './format';

export const ProfileStats = ({ stats, achievementsTotal }) => {
  const winSub = stats.win_rate == null ? 'No finished trades yet' : `${stats.wins}W · ${stats.losses}L`;
  const items = [
    { key: 'total-trades', label: 'Total Trades', value: stats.total_trades.toLocaleString(), sub: `${stats.binary_trades} binary · ${stats.arbitrage_trades} arbitrage`, Icon: Activity, color: 'from-purple-600 to-violet-500' },
    { key: 'win-rate', label: 'Win Rate', value: stats.win_rate == null ? '—' : `${stats.win_rate}%`, sub: winSub, Icon: TrendingUp, color: 'from-teal-600 to-emerald-500' },
    { key: 'account-age', label: 'Account Age', value: fmtAccountAge(stats.account_age_days), sub: `Volume ${fmtUsd(stats.total_volume)}`, Icon: Calendar, color: 'from-fuchsia-600 to-purple-600' },
    { key: 'achievements', label: 'Achievements', value: `${stats.achievements_unlocked}/${achievementsTotal}`, sub: 'Badges earned', Icon: Award, color: 'from-amber-500 to-orange-600' },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {items.map(({ key, label, value, sub, Icon, color }, i) => (
        <div key={key} className="glow-card p-5 sm:p-6 rounded-xl animate-fade-in" style={{ animationDelay: `${i * 60}ms` }} data-testid={`profile-stat-${key}`}>
          <div className={`w-11 h-11 bg-gradient-to-br ${color} rounded-xl flex items-center justify-center mb-4`}>
            <Icon className="h-5 w-5 text-white" />
          </div>
          <p className="text-gray-400 text-sm mb-1">{label}</p>
          <h3 className="text-2xl font-bold" data-testid={`profile-stat-${key}-value`}>{value}</h3>
          <p className="text-xs text-gray-500 mt-1">{sub}</p>
        </div>
      ))}
    </div>
  );
};

export default ProfileStats;
